import styled from 'styled-components'

export const AnnouncementSection = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;

`
export const AnnouncementContainer = styled.div`
	width: 100%;
	background: transparent;
`
